module.exports = ".tbl-btn {\r\n    width: auto;\r\n}"